import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { XMarkIcon } from '@heroicons/react/24/solid'
import { useAuth } from '../hooks/useAuth'

// Note: pt-BR translation support for this banner arrives with VH-17
// (Multi-Language Capabilities). Ships with en + de only for now.
const DISMISS_KEY = 'demo_banner_dismissed'

export default function DemoBanner() {
  const { t } = useTranslation()
  const { user } = useAuth()
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    if (sessionStorage.getItem(DISMISS_KEY) === '1') {
      setVisible(false)
    }
  }, [])

  if (!user || user.is_demo !== true) {
    return null
  }

  if (!visible) {
    return null
  }

  const handleDismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, '1')
    setVisible(false)
  }

  return (
    <div
      role="status"
      className="sticky top-0 z-20 bg-yellow-100 border-b border-yellow-300 text-yellow-900 px-4 py-2 text-sm flex items-center justify-between"
    >
      <span>{t('demo.banner')}</span>
      <button
        type="button"
        onClick={handleDismiss}
        aria-label={t('common.close')}
        className="ml-4 p-1 rounded-full text-yellow-900 hover:bg-yellow-200 focus:outline-none focus:ring-2 focus:ring-yellow-500"
      >
        <XMarkIcon className="h-4 w-4" />
      </button>
    </div>
  )
}
